import { INQUIRY_ACTION } from '../../interfaces/IInquiry';

export const initialShareData = {
	sharePrice: 25,
	// shareNumber: 100,
	blockSize: 150000,
	action: INQUIRY_ACTION.SELL,
};
